<template>
  <div class="row">
    <div class="col-12 mb-3">
      <div class="card shadow bg-gray-200 p-4">
        <div class="card-body">
          <div class="row text-center text-md-start">
            <div class="col-12 col-md-1 my-auto d-flex">
              <div class="d-flex m-auto position-relative">
                <v-file
                  input-id="logo-company"
                  path="logo"
                  module-name="company"
                  getter-name="get"
                  label="Votre fichier"
                  :getter-function="({ logo }) => logo"
                  class="d-none"
                  :setter-callback="openLogoModal"
                />
                <v-icon
                  class="position-absolute cursor-pointer"
                  icon="pen"
                  style="right: -20px; top: -10px"
                  @click="openInputFile"
                />
                <img
                  v-if="!haveLogo"
                  :src="`${aws}/image-profil.png`"
                  class="rounded-circle"
                  height="70"
                  width="70"
                >
                <div
                  v-else
                  class="rounded-circle bg-white overflow-hidden"
                  style="width: 70px; height: 70px"
                >
                  <img
                    :src="company.logoUrl"
                    class="img-fluid"
                  >
                </div>
              </div>
            </div>
            <div class="col-12 col-md-4 ms-md-5 my-md-auto mt-3">
              <div class="d-flex flex-column">
                <div class="h1">
                  {{ client.firstName }} {{ client.lastName }}
                </div>
                <div> {{ client.position.label }} de {{ company.name }} </div>
              </div>
            </div>
            <div
              v-if="percentageCompleted < 100"
              class="col-12 col-md-6 d-flex flex-column justify-content-center mt-3 mt-md-0"
            >
              <div class="d-flex justify-content-between align-items-center mb-2">
                <span class="fw-bold">Profil complet à {{ percentageCompleted }}%</span>
                <button
                  type="button"
                  class="btn btn-sm btn-primary"
                  @click="$router.push('/client/account/companies/company')"
                >
                  Compléter mon profil
                </button>
              </div>
              <div class="progress-bar-container">
                <div
                  class="progress-bar-fill"
                  :style="{ width: percentageCompleted + '%' }"
                >
                  <div class="progress-bar-shine" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-for="(card, index) in cards"
      :key="card.title"
      class="col-12 col-md-6 col-xl-3 mb-3"
    >
      <router-link
        v-slot="{ navigate }"
        :to="card.path"
        custom
      >
        <div
          class="card text-center shadow cursor-pointer"
          style="min-height:264px"
        >
          <div
            class="card-body d-flex flex-column transition-shadow
              justify-content-around rounded-4"
            :class="`box-shadow-${card.color} box-shadow-hover-${card.color}`"
            @mouseover="card.hover = true"
            @mouseleave="card.hover = false"
            @click="navigate"
          >
            <span
              v-for="i in 3"
              :key="i"
              class="pills-image"
              :class="[ `pill-card-${index + 1}-${i}` ]"
            />
            <h5 class="d-flex mx-auto">
              {{ card.title }}
            </h5>
            <div class="d-flex mx-auto">
              <v-icon
                :icon="card.hover ? card.icon + '-off' : card.icon"
                folder="dashboard/svg/account"
                width="100"
                height="70"
              />
            </div>
          </div>
        </div>
      </router-link>
    </div>
    <div class="col-12 mt-3">
      <delete-account-card @delete-account="handleDeleteAccount" />
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import { ui } from '@/mixins';

import File from '@/components/common/input/File.vue';
import DeleteAccountCard from './informations/DeleteAccountCard.vue';

export default {
  name: 'AccountHome',
  components: {
    'v-file': File,
    DeleteAccountCard,
  },
  mixins: [ui],
  data() {
    return {
      cards: [
        {
          title: 'Informations',
          color: 'pink-300',
          icon: 'contact-book',
          path: '/client/account/informations',
          hover: false,
        },
        {
          title: 'Votre mot de passe',
          color: 'blue-300',
          icon: 'lock-pad',
          path: '/client/account/password',
          hover: false,
        },
        {
          title: 'Vos infos bancaires',
          color: 'yellow-300',
          icon: 'wallet',
          path: '/client/account/payments',
          hover: false,
        },
        {
          title: 'Mes entreprises',
          color: 'green-300',
          icon: 'document',
          path: '/client/account/companies',
          hover: false,
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      client: 'client/get',
      company: 'company/get',
    }),
    aws: () => `${import.meta.env.VITE_AWS_STATIC}/dashboard/png/account`,
    percentageCompleted() {
      const fields = ['name', 'siret', 'address', 'codeNaf', 'formeJuridique', 'reportedRevenue'];
      const completedFields = fields.filter(field => this.company[field] !== null).length;
      return Math.round((completedFields / fields.length) * 100);
    },
    haveLogo() {
      return this.company.logoUrl !== null;
    },
  },
  methods: {
    disconnect() {
      this.$store.dispatch('disconnect');
      this.$router.push('/login');
    },
    openInputFile() {
      this.$children[0].$refs.fileInput.click();
    },
    async openLogoModal() {
      await this.$store.dispatch('company/uploadLogo');
      await this.$store.dispatch('company/setCompanyById', this.$store.getters['company/companyId']);
      await this.$store.dispatch('ui/showModalAccount', { value: true, type: 'default' });
    },
    handleDeleteAccount() {
      this.ui_showModalDeleteAccount();
    },
  },
};
</script>
<style scoped>
.progress-bar-container {
  height: 12px;
  background-color: #e9ecef;
  border-radius: 100px;
  overflow: hidden;
  position: relative;
  box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.1);
}

.progress-bar-fill {
  height: 100%;
  background: linear-gradient(90deg, var(--bs-pink-500) 0%, var(--bs-pink-400) 100%);
  border-radius: 100px;
  transition: width 0.6s ease-in-out;
  position: relative;
  overflow: hidden;
}

.progress-bar-shine {
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 255, 255, 0.3),
    transparent
  );
  animation: shine 2s infinite;
}

@keyframes shine {
  0% {
    left: -100%;
  }
  50%, 100% {
    left: 100%;
  }
}

.pills-image {
  height: 12px;
  border-radius: 60px;
  position: absolute;
  z-index: 3;
}

.pill-card-1-1 {
  left: 20px;
  width: 39px;
  top: 35%;
  background-color: var(--bs-yellow-300);
}
.pill-card-1-2 {
  left: 30px;
  width: 64px;
  bottom: 10%;
  background-color: var(--bs-green-300);
}
.pill-card-1-3 {
  bottom: 14%;
  width: 48px;
  right: 30px;
  background-color: var(--bs-pink-300);
}

.pill-card-2-1 {
  top: 37%;
  right: 20px;
  width: 48px;
  background-color: var(--bs-blue-300);
}
.pill-card-2-2 {
  left: 30px;
  width: 50px;
  height: 10px;
  bottom: 20%;
  background-color: var(--bs-green-300);
}
.pill-card-2-3 {
  bottom: 10%;
  width: 33px;
  right: 30px;
  background-color: var(--bs-pink-300);
}

.pill-card-3-1 {
  top: 30%;
  width: 39px;
  height: 8px;
  right: 30px;
  background-color: var(--bs-yellow-300);
}
.pill-card-3-2 {
  bottom: 17%;
  width: 30px;
  right: 30px;
  background-color: var(--bs-green-300);
}
.pill-card-3-3 {
  bottom: 20%;
  width: 32px;
  left: 40px;
  background-color: var(--bs-blue-300);
}

.pill-card-4-1 {
  top: 35%;
  width: 32px;
  left: 20px;
  background-color: var(--bs-blue-300);
}
.pill-card-4-2 {
  bottom: 20%;
  width: 32px;
  left: 40px;
  background-color: var(--bs-yellow-300);
}
.pill-card-4-3 {
  bottom: 13%;
  width: 48px;
  right: 30px;
  background-color: var(--bs-pink-300);
}
</style>
